import Folder from "./SVG/folder.svg?react";

const FolderIcon = () => {
  return <Folder />;
};

export default FolderIcon;
